.section {
  padding: 4.5rem 0;
  border-top: 1px solid var(--zen-border);
  border-bottom: 1px solid var(--zen-border);
  background: var(--zen-bg-elevated);
}

.container {
  max-width: 56rem;
  margin: 0 auto;
  padding: 0 1rem;
}

@media (min-width: 640px) {
  .container { padding: 0 1.5rem; }
}

.heading {
  margin: 0 0 2rem;
  font-size: clamp(1.65rem, 4vw, 2.25rem);
  font-weight: 740;
  letter-spacing: -0.035em;
  color: var(--zen-text-primary);
}

.steps {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid var(--zen-border);
  border-radius: 14px;
  background: var(--zen-bg-surface);
}

.step {
  min-width: 0;
  padding: 1.5rem;
  border-right: 1px solid var(--zen-border);

  &:last-child { border-right: 0; }
}

.stepLeft {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stepNumber {
  display: flex;
  height: 2.5rem;
  width: 2.5rem;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--zen-border);
  border-radius: 9px;
  background: var(--zen-teal-dim);
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--zen-teal-strong);
}

.stepLine { display: none; }

.stepContent {
  flex: 1;
  margin-top: 1.25rem;
  overflow: hidden;
}

.stepTitle {
  margin-bottom: 0.25rem;
  font-size: 1rem;
  font-weight: 700;
  color: var(--zen-text-primary);
}

.stepDesc {
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
  color: var(--zen-text-secondary);
}

.stepContent pre {
  margin: 1rem 0 0;
  padding: 0.8rem 0.9rem;
  overflow-x: auto;
  border: 1px solid var(--zen-border);
  border-radius: 9px;
  background: var(--zen-code);
  color: #74e4c3;
  font-size: 0.72rem;
  line-height: 1.55;

  code { white-space: nowrap; }
}

@media (max-width: 760px) {
  .section { padding: 3.5rem 0; }
  .steps { grid-template-columns: 1fr; }
  .step { border-right: 0; border-bottom: 1px solid var(--zen-border); }
  .step:last-child { border-bottom: 0; }
}
